const Vr1 = () => {

    return (
      <div style={{ width: "100%", height: "100vh" }}>
        <iframe
          src={`https://hitimperial.github.io/VR360-8/PNG%20n.1/3d%20%208-1/publish%208-1/`}
          width="100%"
          height="100%"
          style={{ border: "none" }}
          allowFullScreen
          title="VR 8 Level 1 Tour"
        ></iframe>
      </div>
    );
};

export default Vr1;
